import React from "react";
import { Modal } from "react-bootstrap";

function RegistrationGuide(props) {
  return (
    <Modal
      id="about"
      size="lg"
      show={props.regGuideModal}
      onHide={props.handleCloseModal}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton className="border-0 pb-0 px-4 pt-4">
        <Modal.Title id="example-modal-sizes-title-lg" className="fw-bold" style={{ color: 'var(--primary-dark)', fontSize: '1.25rem' }}>
          Registration Guide
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 pb-4">
        <div className="registration-guide-content mt-3">
          <ul
            style={{
              listStyleType: "none",
              padding: "0",
              margin: "0"
            }}
          >
            {[
              <>Make payment for registration (N2,000) directly/transfer to our Keystone Bank Account Number: <b>1012305244</b></>,
              <>Log-on to our website: <a href="https://www.lmcsnigltd.org.ng" target="_blank" rel="noopener noreferrer">www.lmcsnigltd.org.ng</a></>,
              <>Click on Login/Register</>,
              <>Click on Register and fill your registration details (Payment, Employment & Personal details). <br/><small className="text-muted">Note: Transaction ID can be the teller/transfer number or the name of the payer if no transaction number is available.</small></>,
              <>Check the agreement checkbox and click on Register. It takes you to your Dashboard/Profile. You can review and edit your details before final submission.</>,
              <>Click on <b>Savings & Share Capital</b> on your Dashboard, select initial instruction and fill the form. Click on submit or edit as needed.</>
            ].map((item, index) => (
              <li key={index} className="d-flex gap-3 mb-3 pb-3 border-bottom border-light align-items-start">
                <span className="d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '24px', height: '24px', background: 'var(--primary)', color: '#fff', borderRadius: '50%', fontSize: '0.8rem', fontWeight: 'bold' }}>
                  {index + 1}
                </span>
                <p className="m-0" style={{ fontSize: '0.95rem', color: '#4a5568', lineHeight: '1.5' }}>{item}</p>
              </li>
            ))}
          </ul>
          
          <div className="alert alert-info border-0 mt-4" style={{ borderRadius: '12px', background: 'rgba(var(--primary-rgb, 4, 114, 77), 0.1)', color: 'var(--primary-dark)' }}>
            <p className="mb-2" style={{ fontSize: '0.9rem' }}>
              <strong>Important Note:</strong> Once your registration and instructions are reviewed, you will receive an acknowledgement email.
            </p>
            <p className="mb-0" style={{ fontSize: '0.9rem' }}>
              Providing false information may result in your application being declined.
            </p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default RegistrationGuide;
